module.exports = __webpack_public_path__ + "img/6.d57ef0ab.png";